import React, {useState} from "react";
import {Link, useLocation} from "react-router-dom";
import {FaCopy, FaLink} from "react-icons/fa";
import {RadarchartPreview} from "./render";

export const Radarchart = () => {
    const [copied, setCopied] = useState(false);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const [environment, setEnvironment] = useState(queryParams.get("environment") || "DEV");

    const [serie1Exist, setSerie1Exist]= useState(queryParams.get("serie1Exist") || "Y");
    const [serieName1, setSerieName1]= useState(queryParams.get("serieName1") || "18-30");
    const [serieValues1, setSerieValues1]= useState(queryParams.get("serieValues1") || "30,42,55");

    const [serie2Exist, setSerie2Exist]= useState(queryParams.get("serie2Exist") || "Y");
    const [serieName2, setSerieName2]= useState(queryParams.get("serieName2") || "31-40");
    const [serieValues2, setSerieValues2]= useState(queryParams.get("serieValues2") || "52,0,23");

    const [serie3Exist, setSerie3Exist]= useState(queryParams.get("serie3Exist") || "Y");
    const [serieName3, setSerieName3]= useState(queryParams.get("serieName3") || "41-50");
    const [serieValues3, setSerieValues3]= useState(queryParams.get("serieValues3") || "12,11,19");

    const [serie4Exist, setSerie4Exist]= useState(queryParams.get("serie4Exist") || "N");
    const [serieName4, setSerieName4]= useState(queryParams.get("serieName4") || "");
    const [serieValues4, setSerieValues4]= useState(queryParams.get("serieValues4") || "");

    const [serie5Exist, setSerie5Exist]= useState(queryParams.get("serie5Exist") || "N");
    const [serieName5, setSerieName5]= useState(queryParams.get("serieName5") || "");
    const [serieValues5, setSerieValues5]= useState(queryParams.get("serieValues5") || "");


    const [categories, setCategories] = useState(queryParams.get("categories") || "male,female,other");
    const [showLegend, setShowLegend] = useState(queryParams.get("showLegend") || "Y");
    const [legendPosition, setLegendPosition] = useState(queryParams.get("legendPosition") || "bottom");
    const [seriesColor, setSeriesColor] = useState(queryParams.get("seriesColor") || "0066FF,01087A,0000FF,D6E4F9,E4F3FF,02087A,262ca3,383c7a");
    const [fontFamily, setFontFamily] = useState(queryParams.get("fontFamily") || "Arial, sans-serif");


    const [colorBackground, setColorBackground] = useState(queryParams.get("colorBackground") || "EDEDED");

    const linkToCopy =
        process.env.REACT_APP_FRONT_URL + "/radarchart?na=1"
        + "&environment=PROD"
        + "&categories=" + categories
        + "&showLegend=" + showLegend
        + "&legendPosition=" + legendPosition
        + "&seriesColor=" + seriesColor
        + "&fontFamily=" + fontFamily
        + "&serie1Exist=" + serie1Exist
        + "&serieName1=" + serieName1
        + "&serieValues1=" + serieValues1
        + "&serie2Exist=" + serie2Exist
        + "&serieName2=" + serieName2
        + "&serieValues2=" + serieValues2
        + "&serie3Exist=" + serie3Exist
        + "&serieName3=" + serieName3
        + "&serieValues3=" + serieValues3
        + "&serie4Exist=" + serie4Exist
        + "&serieName4=" + serieName4
        + "&serieValues4=" + serieValues4
        + "&serie5Exist=" + serie5Exist
        + "&serieName5=" + serieName5
        + "&serieValues5=" + serieValues5
        + "&colorBackground=" + colorBackground;




    const handleCopy = () => {
        navigator.clipboard.writeText(linkToCopy);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };



    return (
        <div className="flex flex-col items-center justify-center" style={{width:'100%',height:'100%', backgroundColor:colorBackground}}>
            {environment=== "DEV" && (
                <>
                    <h1 style={{fontSize: 40, fontWeight: 'bold'}}>
                        Radar Chart Card Component
                    </h1>
                    <br/><br/>
                    <h3 className="text-lg font-semibold mb-3">QUERY PARAMETERS</h3>
                    <br/>

                    <h3 className="text-md font-semibold mb-3 mt-10">Chart configuration</h3>
                    <div className="flex flex-wrap items-start justify-start gap-4 w-full">

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">categories</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Identificar todas las categorias de la grafica
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setCategories(e.target.value)}
                                        value={categories}
                                    />
                                </p>
                            </div>
                        </div>


                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">seriesColor</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Colores de las series
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setSeriesColor(e.target.value)}
                                        value={seriesColor}
                                    />
                                </p>
                            </div>
                        </div>


                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">showLegend</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Muestra leyenda con las etiquetas
                                    <br/>
                                    <select
                                        className="block w-full mt-1 px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                        onChange={(e) => setShowLegend(e.target.value)}
                                        value={showLegend}>
                                        <option value="Y">Y</option>
                                        <option value="N">N</option>
                                    </select>
                                </p>
                            </div>
                        </div>


                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">legendPosition</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Ubicacion de la legenda
                                    <br/>
                                    <select
                                        className="block w-full mt-1 px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                        onChange={(e) => setLegendPosition(e.target.value)}
                                        value={legendPosition}>
                                        <option value="right">right</option>
                                        <option value="left">left</option>
                                        <option value="bottom">bottom</option>
                                        <option value="top">top</option>
                                    </select>
                                </p>
                            </div>
                        </div>

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">fontFamily</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Tipografia
                                    <br/>
                                    <select
                                        className="block w-full mt-1 px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                        onChange={(e) => setFontFamily(e.target.value)}
                                        value={fontFamily}>
                                        <option value="Arial, sans-serif">Arial, sans-serif</option>
                                        <option value="Courier New, monospace">Courier New, monospace</option>
                                        <option value="Helvetica, sans-serif">Helvetica, sans-serif</option>
                                        <option value="Verdana, sans-serif">Verdana, sans-serif</option>
                                        <option value="Tahoma, sans-serif">Tahoma, sans-serif</option>
                                        <option value="Trebuchet MS, sans-serif">Trebuchet MS, sans-serif</option>
                                        <option value="Open Sans, sans-serif">Open Sans, sans-serif</option>
                                        <option value="Roboto, sans-serif">Roboto, sans-serif</option>
                                    </select>
                                </p>
                            </div>
                        </div>


                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>

                        </div>


                        {/* Series 1 */}
                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">serie1Exist</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Existe o no la serie
                                    <br/>
                                    <select
                                        className="block w-full mt-1 px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                        onChange={(e) => setSerie1Exist(e.target.value)}
                                        value={serie1Exist}>
                                        <option value="Y">Y</option>
                                        <option value="N">N</option>
                                    </select>
                                </p>
                            </div>
                        </div>

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">serieName1</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Nombre de la serie
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setSerieName1(e.target.value)}
                                        value={serieName1}
                                    />
                                </p>
                            </div>
                        </div>


                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">serieValues1</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Valores series1 separados por coma
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setSerieValues1(e.target.value)}
                                        value={serieValues1}
                                    />
                                </p>
                            </div>
                        </div>


                        {/* Series 2 */}
                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">serie2Exist</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Existe o no la serie
                                    <br/>
                                    <select
                                        className="block w-full mt-1 px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                        onChange={(e) => setSerie2Exist(e.target.value)}
                                        value={serie2Exist}>
                                        <option value="Y">Y</option>
                                        <option value="N">N</option>
                                    </select>
                                </p>
                            </div>
                        </div>

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">serieName2</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Nombre de la serie
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setSerieName2(e.target.value)}
                                        value={serieName2}
                                    />
                                </p>
                            </div>
                        </div>


                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">serieValues2</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Valores series1 separados por coma
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setSerieValues2(e.target.value)}
                                        value={serieValues2}
                                    />
                                </p>
                            </div>
                        </div>





                        {/* Series 3 */}
                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">serie3Exist</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Existe o no la serie
                                    <br/>
                                    <select
                                        className="block w-full mt-1 px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                        onChange={(e) => setSerie3Exist(e.target.value)}
                                        value={serie3Exist}>
                                        <option value="Y">Y</option>
                                        <option value="N">N</option>
                                    </select>
                                </p>
                            </div>
                        </div>

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">serieName3</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Nombre de la serie
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setSerieName3(e.target.value)}
                                        value={serieName3}
                                    />
                                </p>
                            </div>
                        </div>


                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">serieValues3</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Valores series1 separados por coma
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setSerieValues3(e.target.value)}
                                        value={serieValues3}
                                    />
                                </p>
                            </div>
                        </div>






                        {/* Series 4 */}
                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">serie4Exist</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Existe o no la serie
                                    <br/>
                                    <select
                                        className="block w-full mt-1 px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                        onChange={(e) => setSerie4Exist(e.target.value)}
                                        value={serie4Exist}>
                                        <option value="Y">Y</option>
                                        <option value="N">N</option>
                                    </select>
                                </p>
                            </div>
                        </div>

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">serieName4</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Nombre de la serie
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setSerieName4(e.target.value)}
                                        value={serieName4}
                                    />
                                </p>
                            </div>
                        </div>


                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">serieValues4</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Valores series1 separados por coma
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setSerieValues4(e.target.value)}
                                        value={serieValues4}
                                    />
                                </p>
                            </div>
                        </div>




                        {/* Series 5 */}
                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">serie5Exist</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Existe o no la serie
                                    <br/>
                                    <select
                                        className="block w-full mt-1 px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                        onChange={(e) => setSerie5Exist(e.target.value)}
                                        value={serie5Exist}>
                                        <option value="Y">Y</option>
                                        <option value="N">N</option>
                                    </select>
                                </p>
                            </div>
                        </div>

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">serieName5</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Nombre de la serie
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setSerieName5(e.target.value)}
                                        value={serieName5}
                                    />
                                </p>
                            </div>
                        </div>


                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">serieValues5</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Valores series5 separados por coma
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setSerieValues5(e.target.value)}
                                        value={serieValues5}
                                    />
                                </p>
                            </div>
                        </div>


                    </div>
                    <h3 className="text-lg font-semibold mb-3">PREVIEW</h3>


                    <br/><br/>
                </>)}

            <RadarchartPreview
                colorBackground={colorBackground}
                categories={categories}
                showLegend={showLegend}
                legendPosition={legendPosition}
                seriesColor={seriesColor}
                fontFamily={fontFamily}

                serie1Exist={serie1Exist}
                serieName1={serieName1}
                serieValues1={serieValues1}
                serie2Exist={serie2Exist}
                serieName2={serieName2}
                serieValues2={serieValues2}
                serie3Exist={serie3Exist}
                serieName3={serieName3}
                serieValues3={serieValues3}
                serie4Exist={serie4Exist}
                serieName4={serieName4}
                serieValues4={serieValues4}
                serie5Exist={serie5Exist}
                serieName5={serieName5}
                serieValues5={serieValues5}

            />


            {environment === "DEV" && (
                <div>
                    <br/><br/>
                    <div className="flex items-center mb-5">
                        <button
                            onClick={handleCopy}
                            className="mr-4 bg-blue-500 text-white p-2 rounded-lg flex items-center hover:bg-blue-600"
                        >
                            <FaCopy className="mr-2"/>
                            {copied ? "Copied!" : "Copy Link"}
                        </button>
                        <Link to={"/"}>
                            <button className="mr-4 bg-blue-500 text-white p-2 rounded-lg flex items-center hover:bg-blue-600" >
                                <FaLink className="mr-2"/>
                                Go to Home
                            </button>
                        </Link>
                    </div>

                </div>
            )}
        </div>

    );
};
